import {
  writeBatch,
  doc,
  deleteDoc,
  collection,
  getDocs,
} from "firebase/firestore";
import { getStorage, ref, deleteObject } from "firebase/storage";

function deleteImages(imgRef) {
  return new Promise((resolve, reject) => {
    deleteObject(imgRef)
      .then(() => {
        resolve("delete image done");
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const deleteProductById = async (id, db, storage, productsWithLabel) => {
  const docRef = doc(db, "products", id);
  const imgProdRef = ref(storage, productsWithLabel[id].pathStorageImage);

  await deleteImages(imgProdRef);
  await deleteDoc(docRef);
};

const DeleteProducts = async (selected, db) => {
  if (selected.length > 0) {
    const productsRef = collection(db, "products");
    const storage = getStorage();
    const snapshot = await getDocs(productsRef);
    const productDataLabel = {};
    snapshot.forEach((doc) => {
      productDataLabel[doc.id] = doc.data();
    });

    if (selected.length > 1) {
      const deletePromises = selected.map((id) =>
        deleteProductById(id, db, storage, productDataLabel)
      );
      return Promise.all(deletePromises);
    }
    const id = selected[0];
    return Promise.resolve(
      deleteProductById(id, db, storage, productDataLabel)
    );
  }

  return Promise.resolve("done");
};

export { DeleteProducts };
